import { Col, Image, Row, Typography, List, Button } from "antd";
import { Content } from "antd/lib/layout/layout";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  DigitalDistribution,
  Marketing,
  PhysicalDistribution,
  ServiceImg,
  ServiceImg2,
  ServiceImg3,
  ServiceImg4,
  ServiceImg5,
  ServiceLogo2,
  TradeAccount,
  VinylManufacturing,
  AAndBees,
  Arco,
  BeeYou,
  ChampionRecords,
  CondensedTransparent,
  EarthlyMeasures,
  GoodVibrations,
  KaozTheory,
  Kookoo1,
  Kookoo,
  LogoBlackTransparent,
  LogoSoloFontBianconero,
  LogoStampaHellYeahBlack,
  LoveFaceMusic,
  MajorKeys,
  MultiCulti,
  PrimeDistLogo,
  QuantizeRecordings,
  RazorNTape,
  Selador,
  Situationism,
  SnatchLogoStackWhite,
  SouthStreet,
  SouthStreetDisco,
  SouthStreetInternational,
  SouthStreetSoul,
  TrmnlLogo,
  TropicalDisco,
  UtsLogo,
  UtsLogoWhite,
  RECORDS326,
  MUSIC1985,
  ALBERTSFAVE,
  ARISTA1,
  BECKETRECORDS,
  BOBBYDONNY,
  BUDDAHRECORDS,
  CABARETRECORDS,
  CLUBSWEAT,
  COLUMBIA1,
  DCLTD1,
  DENNISQUIN,
  DIGITALTAPERECORDINGS,
  DEPPINRECORDS,
  DIVINEDISCS,
  DRUMCODE1,
  EASTENDERZ1,
  EPIC1,
  EVERYSOUL1,
  FAITH1,
  FOODMUSIC,
  FUSE1,
  GALLERYRECORDS,
  HEELSANDSOULSRECORDINGS,
  HOOJCHOONS,
  HOUSEOFEFUNCK,
  INFUSE1,
  KUDURECORDS,
  LAZYDAYS,
  LOCUS1,
  MADRECORDS,
  MOBLACKRECORDS,
  NUGROOVE,
  NUNUORTHERNSOUL,
  OVERSHADOW1,
  PEPPERMITJAM,
  PHILADELPHIAINTERNATIONAL,
  TRUESOUL1,
  WOLF1,
} from "../../assets/images";
import MainHeading from "../mainHeading";
import ServiceList from "../serviceList";
import pdfFile from "../../assets/Account-Application.pdf";
import {
  storeLabelsValue,
  storeProductReleaseEnumValue,
} from "../../store/products/productsActions";
import { useDispatch } from "react-redux";

const ServicesContent = (props: any) => {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // You can adjust the threshold according to your needs
    };

    // Listen to window resize events
    window.addEventListener("resize", handleResize);

    // Call the handler once to set the initial value
    handleResize();

    // Cleanup the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const array1 = [
    { id: 1, logo: AAndBees, name: "A’s and Bees" },
    { id: 2, logo: Arco, name: "Archipelago" },
    { id: 3, logo: BeeYou, name: "Beeyou Records" },
    { id: 4, logo: ChampionRecords, name: "Champion" },
  ];

  const array2 = [
    { id: 5, logo: CondensedTransparent, name: "Celestial Echo" },
    { id: 6, logo: EarthlyMeasures, name: "Earthly Measures" },
    { id: 7, logo: GoodVibrations, name: "Good Vibrations Music" },
    { id: 8, logo: KaozTheory, name: "Kaoz Theory" },
  ];

  const array3 = [
    { id: 9, logo: ServiceLogo2, name: "Z Records" },
    { id: 10, logo: Kookoo, name: "KOOKOO" },
    { id: 12, logo: LogoBlackTransparent, name: "Panorama" },
    { id: 13, logo: LogoSoloFontBianconero, name: "Groove Culture" },
  ];

  const array4 = [
    { id: 14, logo: LogoStampaHellYeahBlack, name: "Hell Yeah Recordings" },
    { id: 15, logo: LoveFaceMusic, name: "Loveface Music" },
    { id: 16, logo: MajorKeys, name: "Major Keys" },
    { id: 17, logo: MultiCulti, name: "Multi Culti" },
  ];

  const array5 = [
    { id: 18, logo: PrimeDistLogo, name: "Homegrown." },
    { id: 19, logo: QuantizeRecordings, name: "Quantize Recordings" },
    { id: 20, logo: RazorNTape, name: "Razor-N-Tape" },
    { id: 21, logo: Selador, name: "Selador Recordings" },
  ];

  const array6 = [
    { id: 22, logo: Situationism, name: "Situationism" },
    { id: 23, logo: SnatchLogoStackWhite, name: "Snatch Raw" },
    { id: 24, logo: SouthStreet, name: "South Street" },
    { id: 25, logo: SouthStreetDisco, name: "South Street Disco" },
  ];

  const array7 = [
    {
      id: 26,
      logo: SouthStreetInternational,
      name: "South Street International",
    },
    { id: 27, logo: SouthStreetSoul, name: "South Street Soul" },
    { id: 28, logo: TrmnlLogo, name: "TRMNL" },
    { id: 29, logo: TropicalDisco, name: "Tropical Disco Records" },
  ];

  const array8 = [
    { id: 30, logo: UtsLogoWhite, name: "Up The Stuss" },
    { id: 31, logo: RECORDS326, name: "326 Records" },
    { id: 32, logo: MUSIC1985, name: "1985 Music" },
    { id: 33, logo: ALBERTSFAVE, name: "Albert’s Favourites" },
    { id: 65, logo: PEPPERMITJAM, name: "Peppermint Jam" },
  ];

  const array9 = [
    { id: 34, logo: ARISTA1, name: "Arista" },
    { id: 35, logo: BECKETRECORDS, name: "Beckett" },
    { id: 36, logo: BOBBYDONNY, name: "Bobby Donny" },
    { id: 37, logo: BUDDAHRECORDS, name: "Buddah" },
    { id: 64, logo: OVERSHADOW1, name: "Over/Shadow" },
  ];

  const array10 = [
    { id: 38, logo: CABARETRECORDS, name: "Cabaret" },
    { id: 39, logo: CLUBSWEAT, name: "Club Sweat" },
    { id: 40, logo: COLUMBIA1, name: "Columbia" },
    { id: 41, logo: DCLTD1, name: "DCLTD" },
    { id: 63, logo: NUNUORTHERNSOUL, name: "NuNorthern Soul" },
  ];

  const array11 = [
    { id: 42, logo: DENNISQUIN, name: "Dennis Quin" },
    { id: 43, logo: DIGITALTAPERECORDINGS, name: "Digital Tape Recordings" },
    { id: 44, logo: DEPPINRECORDS, name: "Dippin’ Records" },
    { id: 45, logo: DIVINEDISCS, name: "Divine Discs" },
    { id: 62, logo: NUGROOVE, name: "Nu Groove Records" },
  ];

  const array12 = [
    { id: 46, logo: DRUMCODE1, name: "Drumcode" },
    { id: 80, logo: EASTENDERZ1, name: "Eastenderz" },
    { id: 47, logo: EPIC1, name: "Epic" },
    { id: 48, logo: EVERYSOUL1, name: "Everysoul Audio" },
    { id: 61, logo: MOBLACKRECORDS, name: "MoBlack Records" },
  ];

  const array13 = [
    { id: 49, logo: FAITH1, name: "Faith" },
    { id: 50, logo: FOODMUSIC, name: "Food Music" },
    { id: 51, logo: FUSE1, name: "Fuse London" },
    { id: 52, logo: GALLERYRECORDS, name: "Gallery" },
    { id: 68, logo: WOLF1, name: "Wolf Music" },
  ];

  const array14 = [
    {
      id: 53,
      logo: HEELSANDSOULSRECORDINGS,
      name: "Heels & Souls Recordings",
    },
    { id: 54, logo: HOOJCHOONS, name: "Hooj" },
    { id: 55, logo: HOUSEOFEFUNCK, name: "House of EFUNK Records" },
    { id: 56, logo: INFUSE1, name: "Infuse" },
    { id: 67, logo: TRUESOUL1, name: "Truesoul" },
  ];

  const array15 = [
    { id: 57, logo: KUDURECORDS, name: "Kudu" },
    { id: 58, logo: LAZYDAYS, name: "Lazy Days" },
    { id: 59, logo: LOCUS1, name: "LOCUS" },
    { id: 60, logo: MADRECORDS, name: "M.A.DRECORDS" },
    {
      id: 66,
      logo: PHILADELPHIAINTERNATIONAL,
      name: "Philadelphia International Records",
    },
  ];

  let data1 = [
    {
      id: 1,
      logo: AAndBees,
      name: "A’s and Bees",
    },
    {
      id: 2,
      logo: Arco,
      name: "Archipelago",
    },
    {
      id: 3,
      logo: BeeYou,
      name: "Beeyou Records",
    },
    {
      id: 4,
      logo: ChampionRecords,
      name: "Champion",
    },
    {
      id: 5,
      logo: CondensedTransparent,
      name: "Celestial Echo",
    },
    {
      id: 6,
      logo: EarthlyMeasures,
      name: "Earthly Measures",
    },
    {
      id: 7,
      logo: GoodVibrations,
      name: "Good Vibrations Music",
    },
    {
      id: 8,
      logo: KaozTheory,
      name: "Kaoz Theory",
    },
    {
      id: 9,
      logo: ServiceLogo2,
      name: "Z Records",
    },
    {
      id: 10,
      logo: Kookoo,
      name: "KOOKOO",
    },
    {
      id: 12,
      logo: LogoBlackTransparent,
      name: "Panorama",
    },
    {
      id: 13,
      logo: LogoSoloFontBianconero,
      name: "Groove Culture",
    },
    {
      id: 14,
      logo: LogoStampaHellYeahBlack,
      name: "Hell Yeah Recordings",
    },
    {
      id: 15,
      logo: LoveFaceMusic,
      name: "Loveface Music",
    },
    {
      id: 16,
      logo: MajorKeys,
      name: "Major Keys",
    },
  ];

  let pendingList = [
    {
      id: 17,
      logo: MultiCulti,
      name: "Multi Culti",
    },
    {
      id: 18,
      logo: PrimeDistLogo,
      name: "Homegrown.",
    },
    {
      id: 19,
      logo: QuantizeRecordings,
      name: "Quantize Recordings",
    },
    {
      id: 20,
      logo: RazorNTape,
      name: "Razor-N-Tape",
    },
    {
      id: 21,
      logo: Selador,
      name: "Selador Recordings",
    },
    {
      id: 22,
      logo: Situationism,
      name: "Situationism",
    },
    {
      id: 23,
      logo: SnatchLogoStackWhite,
      name: "Snatch Raw",
    },
    {
      id: 24,
      logo: SouthStreet,
      name: "South Street",
    },
    {
      id: 25,
      logo: SouthStreetDisco,
      name: "South Street Disco",
    },
    {
      id: 26,
      logo: SouthStreetInternational,
      name: "South Street International",
    },
    {
      id: 27,
      logo: SouthStreetSoul,
      name: "South Street Soul",
    },
    {
      id: 28,
      logo: TrmnlLogo,
      name: "TRMNL",
    },
    {
      id: 29,
      logo: TropicalDisco,
      name: "Tropical Disco Records",
    },
    {
      id: 30,
      logo: UtsLogoWhite,
      name: "Up The Stuss",
    },
    {
      id: 31,
      logo: RECORDS326,
      name: "326 Records",
    },
    {
      id: 32,
      logo: MUSIC1985,
      name: "1985 Music",
    },
    {
      id: 33,
      logo: ALBERTSFAVE,
      name: "Albert’s Favourites",
    },
    {
      id: 34,
      logo: ARISTA1,
      name: "Arista",
    },
    {
      id: 35,
      logo: BECKETRECORDS,
      name: "Beckett",
    },
    {
      id: 36,
      logo: BOBBYDONNY,
      name: "Bobby Donny",
    },
    {
      id: 37,
      logo: BUDDAHRECORDS,
      name: "Buddah",
    },
    {
      id: 38,
      logo: CABARETRECORDS,
      name: "Cabaret",
    },
    {
      id: 39,
      logo: CLUBSWEAT,
      name: "Club Sweat",
    },
    {
      id: 40,
      logo: COLUMBIA1,
      name: "Columbia",
    },
    {
      id: 41,
      logo: DCLTD1,
      name: "DCLTD",
    },
    {
      id: 42,
      logo: DENNISQUIN,
      name: "Dennis Quin",
    },
    {
      id: 43,
      logo: DIGITALTAPERECORDINGS,
      name: "Digital Tape Recordings",
    },
    {
      id: 44,
      logo: DEPPINRECORDS,
      name: "Dippin’ Records",
    },
    {
      id: 45,
      logo: DIVINEDISCS,
      name: "Divine Discs",
    },
    {
      id: 46,
      logo: DRUMCODE1,
      name: "Drumcode",
    },
    {
      id: 46,
      logo: EASTENDERZ1,
      name: "Eastenderz",
    },
    {
      id: 47,
      logo: EPIC1,
      name: "Epic",
    },
    {
      id: 48,
      logo: EVERYSOUL1,
      name: "Everysoul Audio",
    },
    {
      id: 49,
      logo: FAITH1,
      name: "Faith",
    },
    {
      id: 50,
      logo: FOODMUSIC,
      name: "Food Music",
    },
    {
      id: 51,
      logo: FUSE1,
      name: "Fuse London",
    },
    {
      id: 52,
      logo: GALLERYRECORDS,
      name: "Gallery",
    },
    {
      id: 53,
      logo: HEELSANDSOULSRECORDINGS,
      name: "Heels & Souls Recordings",
    },
    {
      id: 54,
      logo: HOOJCHOONS,
      name: "Hooj",
    },
    {
      id: 55,
      logo: HOUSEOFEFUNCK,
      name: "House of EFUNK Records",
    },
    {
      id: 56,
      logo: INFUSE1,
      name: "Infuse",
    },
    {
      id: 57,
      logo: KUDURECORDS,
      name: "Kudu",
    },
    {
      id: 58,
      logo: LAZYDAYS,
      name: "Lazy Days",
    },
    {
      id: 59,
      logo: LOCUS1,
      name: "LOCUS",
    },
    {
      id: 60,
      logo: MADRECORDS,
      name: "M.A.DRECORDS",
    },
    {
      id: 61,
      logo: MOBLACKRECORDS,
      name: "MoBlack Records",
    },
    {
      id: 62,
      logo: NUGROOVE,
      name: "Nu Groove Records",
    },
    {
      id: 63,
      logo: NUNUORTHERNSOUL,
      name: "NuNorthern Soul",
    },
    {
      id: 64,
      logo: OVERSHADOW1,
      name: "Over/Shadow",
    },
    {
      id: 65,
      logo: PEPPERMITJAM,
      name: "Peppermint Jam",
    },
    {
      id: 66,
      logo: PHILADELPHIAINTERNATIONAL,
      name: "Philadelphia International Records",
    },
    {
      id: 67,
      logo: TRUESOUL1,
      name: "Truesoul",
    },
    {
      id: 68,
      logo: WOLF1,
      name: "Wolf Music",
    },
  ];

  const [firstList, setFirstList] = useState(data1);
  const [secondList, setSecondList] = useState(pendingList);
  const [timerRunning, setTimerRunning] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [randomIndex1, setIndexNumber1] = useState(0);
  const [rowListIndex1, setRowListIndex1] = useState(0);

  const [prevIndex1, setPrevIndex1] = useState(0);
  const [prevIndex2, setPrevIndex2] = useState(0);
  const [prevIndex3, setPrevIndex3] = useState(0);
  const [prevIndex4, setPrevIndex4] = useState(0);
  const [prevIndex5, setPrevIndex5] = useState(0);

  const [randomIndex2, setIndexNumber2] = useState(0);
  const [rowListIndex2, setRowListIndex2] = useState(0);

  const [prevIndex6, setPrevIndex6] = useState(0);
  const [prevIndex7, setPrevIndex7] = useState(0);
  const [prevIndex8, setPrevIndex8] = useState(0);
  const [prevIndex9, setPrevIndex9] = useState(0);
  const [prevIndex10, setPrevIndex10] = useState(0);

  const [randomIndex3, setIndexNumber3] = useState(0);
  const [rowListIndex3, setRowListIndex3] = useState(0);

  const [prevIndex11, setPrevIndex11] = useState(0);
  const [prevIndex12, setPrevIndex12] = useState(0);
  const [prevIndex13, setPrevIndex13] = useState(0);
  const [prevIndex14, setPrevIndex14] = useState(0);
  const [prevIndex15, setPrevIndex15] = useState(0);

  const [currentListIndex, setCurrentListIndex] = useState<number>(1);
  const [rowIndex1,setRowIndex1] = useState(1);
  const [rowIndex2,setRowIndex2] = useState(1);
  const [rowIndex3,setRowIndex3] = useState(1);

  const dispatch = useDispatch();
  useEffect(() => {
    // Function to randomly swap items
    const swapItems = () => {
      const updatedFirstList = [...firstList];
      const updatedSecondList = [...secondList];

      // Generate random indices for each row of 5 items
      const row1Index = Math.floor(Math.random() * 5);
      const row2Index = Math.floor(Math.random() * 5) + 5; // Start from index 5 for second row
      const row3Index = Math.floor(Math.random() * 5) + 10; // Start from index 10 for third row

      // Ensure we don't go out of bounds in secondList
      const secondListIndex = currentIndex % secondList.length;

      // Perform swaps, ensuring index is within bounds of firstList
      if (
        row1Index < updatedFirstList.length &&
        secondListIndex < updatedSecondList.length
      ) {
        [updatedFirstList[row1Index], updatedSecondList[secondListIndex]] = [
          updatedSecondList[secondListIndex],
          updatedFirstList[row1Index],
        ];
      }

      if (
        row2Index < updatedFirstList.length &&
        secondListIndex < updatedSecondList.length
      ) {
        [updatedFirstList[row2Index], updatedSecondList[secondListIndex]] = [
          updatedSecondList[secondListIndex],
          updatedFirstList[row2Index],
        ];
      }

      if (
        row3Index < updatedFirstList.length &&
        secondListIndex < updatedSecondList.length
      ) {
        [updatedFirstList[row3Index], updatedSecondList[secondListIndex]] = [
          updatedSecondList[secondListIndex],
          updatedFirstList[row3Index],
        ];
      }

      // Update state
      setFirstList(updatedFirstList);
      setSecondList(updatedSecondList);

      // Update currentIndex to the next set of indices
      setCurrentIndex((prevIndex) => prevIndex + 1); // Increment sequentially
    };

    // Interval to run swap every 3 seconds (adjust timing as needed)
    const interval = setInterval(() => {
      if (timerRunning) {
        swapItems();
      }
    }, 3500); // Change interval as per your requirement

    return () => clearInterval(interval);
  }, [timerRunning, firstList, secondList]);

  const toggleTimer = () => {
    setTimerRunning((prev) => !prev);
  };
  const handleClick = (props: any) => {
    const encoded: any = encodeURI(props);
    dispatch(storeLabelsValue(encoded));
    dispatch(storeProductReleaseEnumValue(null));
  };
  const location = useLocation();
  useEffect(() => {
    let top: any;

    if (location?.hash === "#physical-distribution") {
      top = document.getElementById("service1") as HTMLElement;
    } else if (location?.hash === "#digital-distribution") {
      top = document.getElementById("service2") as HTMLElement;
    } else {
      scrollToTop();
    }
    if (top != null) {
      setTimeout(() => {
        top.scrollIntoView();
      }, 150);
    }
  }, [location,isMobile]);
  function sendMail() {
    var link =
      `mailto:info@primedirectdist.co.uk` +
      "?" +
      "&subject=" +
      encodeURIComponent("Marketing Enquiry") +
      "&body=" +
      encodeURIComponent("");
    window.location.href = link;
  }
  useEffect(() => {
    // scrollToTop();
    toggleTimer();
  }, []);

  // Function to generate a random number between 0 and 1000
  function getRandomNumber(min: number, max: number) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  useEffect(() => {
    let timer: NodeJS.Timeout; // Declare timer variable
    const startTimer = () => {
      timer = setInterval(() => {
        setCurrentListIndex((prev) => {
          return prev >= 3 ? 1 : prev + 1;
        });
      }, 5000);
    };
    
    startTimer(); // Start the timer

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if(currentListIndex === 1){
      // const number = getRandomNumber(0, 6);
      setRowListIndex1(rowIndex1);
      switch (rowIndex1) {
        case 1:
          const firstNumber = getRandomNumber(0, 4);
          setPrevIndex1(firstNumber);
          setIndexNumber1(firstNumber);
          setRowIndex1(2);
          break;
        case 2:
          const secondNumber = getRandomNumber(0, 4);
          setPrevIndex2(secondNumber);
          setIndexNumber1(secondNumber);
          setRowIndex1(3);
          break;
        case 3:
          const thirdNumber = getRandomNumber(0, 4);
          setPrevIndex3(thirdNumber);
          setIndexNumber1(thirdNumber);
          setRowIndex1(4);
          break;
        case 4:
          const fourthNumber = getRandomNumber(0, 4);
          setPrevIndex4(fourthNumber);
          setIndexNumber1(fourthNumber);
          setRowIndex1(5);
          break;
        case 5:
          const fithNumber = getRandomNumber(0, 4);
          setPrevIndex5(fithNumber);
          setIndexNumber1(fithNumber);
          setRowIndex1(1);
          break;
      }
    }else if(currentListIndex === 2){
      // const number = getRandomNumber(0, 5);
      setRowListIndex2(rowIndex2);
      switch (rowIndex2) {
        case 1:
          const firstNumber = getRandomNumber(0, 4);
          setPrevIndex6(firstNumber);
          setIndexNumber2(firstNumber);
          setRowIndex2(2);
          break;
        case 2:
          const secondNumber = getRandomNumber(0, 4);
          setPrevIndex7(secondNumber);
          setIndexNumber2(secondNumber);
          setRowIndex2(3);
          break;
        case 3:
          const thirdNumber = getRandomNumber(0, 5);
          setPrevIndex8(thirdNumber);
          setIndexNumber2(thirdNumber);
          setRowIndex2(4);
          break;
        case 4:
          const fourthNumber = getRandomNumber(0, 5);
          setPrevIndex9(fourthNumber);
          setIndexNumber2(fourthNumber);
          setRowIndex2(5);
          break;
        case 5:
          const fithNumber = getRandomNumber(0, 5);
          setPrevIndex10(fithNumber);
          setIndexNumber2(fithNumber);
          setRowIndex2(1);
          break;
      }
    }else if(currentListIndex === 3){
      // const number = getRandomNumber(0, 5);
      setRowListIndex3(rowIndex3);
      switch (rowIndex3) {
        case 1:
          const firstNumber = getRandomNumber(0, 5);
          setPrevIndex11(firstNumber);
          setIndexNumber3(firstNumber);
          setRowIndex3(2);
          break;
        case 2:
          const secondNumber = getRandomNumber(0, 5);
          setPrevIndex12(secondNumber);
          setIndexNumber3(secondNumber);
          setRowIndex3(3);
          break;
        case 3:
          const thirdNumber = getRandomNumber(0, 5);
          setPrevIndex13(thirdNumber);
          setIndexNumber3(thirdNumber);
          setRowIndex3(4);
          break;
        case 4:
          const fourthNumber = getRandomNumber(0, 5);
          setPrevIndex14(fourthNumber);
          setIndexNumber3(fourthNumber);
          setRowIndex3(5);
          break;
        case 5:
          const fithNumber = getRandomNumber(0, 5);
          setPrevIndex15(fithNumber);
          setIndexNumber3(fithNumber);
          setRowIndex3(1);
          break;
      }
    }
    
  }, [currentListIndex]);


  const scrollToTop = () => {
    if(isMobile){
      setTimeout(() => {
        const top = document.getElementById("serviceTop") as HTMLElement;
        top.scrollIntoView();
      }, 300);
    }else{
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth", // This provides smooth scrolling
        });
      }, 300);
     
    }
   
   
  };
  return (
    <div className="our-services services-content" id="serviceTop">
      <div className="container">
        <MainHeading text="Our Services" />
        <Content className="services-listing">
          <ServiceList
            icon={<PhysicalDistribution />}
            id="service1"
            image={ServiceImg}
            title="Physical Distribution"
            description1="With 22+ years’ experience distributing vinyl worldwide, our relationships with the leading UK and International stockists, alongside independent stores across the globe, mean that your releases are best placed to be seen, heard and sold in all the right places."
            description2="The continued resurgence of vinyl is well documented and certainly, there has been a huge uplift in our sales of 7”, 12” and LP’s. We cover all bases from independents, webstores, chains and the Amazon’s globally, and have the know-how and reach to further develop your fan-base. The physical format is still seen as a record label’s best calling card."
            bottomText="Our labels include the likes of Razor-N-Tape ,King Street Sounds, WOLF Music, Toolroom, Drumcode, Dippin’ Records, Nu Groove Records, Slip ‘n’ Slide, Sweat It Out, East End Dubs, Fuse London, Groove Culture, Soul Clap Records, Hell Yeah Recordings, Semi Delicious, 326 Recordings, Test Pressing Recordings, Love International, Kaoz Theory, Moxy Music, M A D Records, Rebirth, South Street Records, Celestial Echo, Albert’s Favourites and many more."
          />
          <ServiceList
            icon={<DigitalDistribution />}
            id="service2"
            class="reverse"
            image={ServiceImg2}
            title="Digital Distribution"
            description1="We pride ourselves on our digital distribution services, distributing to all major Digital Service Providers, music stores and social media platforms including Spotify, Traxsource, Beatport, Itunes, Apple Music, Facebook / Instagram, YouTube, Amazon, Juno Download, Shazam, Tidal and many more. Features, playlists and placements can significantly increase sales and streaming revenue and this is one of our top priorities."
            bottomText="Our labels include the likes of Up the Stuss, WotNot Music, SlothBoogie, Midnight Riot, Punks, CLNE, Suara, SoSure Music, Groove Odyssey, Pinchy & Friends, Spa In Disco, Oddity, Sloth Boogie, Dank N Dirt Dubz, Rossi Homegrown, Beeyou Records, Earthly Measures, Work Them Records, Voyage Recordings and Pomme Frite."
          />
          {/* <List
            className="logos-list"
            dataSource={firstList}
            renderItem={(item) => (
              <List.Item>
                <Link to={`/releases?labelName=${item?.name}`}>
                  <Image
                    onClick={() => handleClick(item?.name)}
                    preview={false}
                    src={item.logo}
                    key={item.logo}
                  />
                </Link>
              </List.Item>
            )}
          /> */}

          <div className="custom-img-gallery-wrapper">
            <div className="custom-img-gallery">
              <div key={1} className="list">
                {array1 &&
                  array1?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex1 === 1 && randomIndex1 === index
                          ? "hide show"
                          : rowListIndex1 !== 1 && prevIndex1 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>
              <div key={2} className="list">
                {array2 &&
                  array2?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex1 === 2 && randomIndex1 === index
                          ? "hide show"
                          : rowListIndex1 !== 2 && prevIndex2 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>
              <div key={3} className="list">
                {array3 &&
                  array3?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex1 === 3 && randomIndex1 === index
                          ? "hide show"
                          : rowListIndex1 !== 3 && prevIndex3 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>
              <div key={4} className="list">
                {array4 &&
                  array4?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex1 === 4 && randomIndex1 === index
                          ? "hide show"
                          : rowListIndex1 !== 4 && prevIndex4 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>
              <div key={5} className="list">
                {array5 &&
                  array5?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex1 === 5 && randomIndex1 === index
                          ? "hide show"
                          : rowListIndex1 !== 5 && prevIndex5 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>
            </div>

            <div className="custom-img-gallery">
              <div key={6} className="list">
                {array6 &&
                  array6?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex2 === 1 && randomIndex2 === index
                          ? "hide show"
                          : rowListIndex2 !== 1 && prevIndex6 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>
              <div key={7} className="list">
                {array7 &&
                  array7?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex2 === 2 && randomIndex2 === index
                          ? "hide show"
                          : rowListIndex2 !== 2 && prevIndex7 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>
              <div key={8} className="list">
                {array8 &&
                  array8?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex2 === 3 && randomIndex2 === index
                          ? "hide show"
                          : rowListIndex2 !== 3 && prevIndex8 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>
              <div key={9} className="list">
                {array9 &&
                  array9?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex2 === 4 && randomIndex2 === index
                          ? "hide show"
                          : rowListIndex2 !== 4 && prevIndex9 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>
              <div key={10} className="list">
                {array10 &&
                  array10?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex2 === 5 && randomIndex2 === index
                          ? "hide show"
                          : rowListIndex2 !== 5 && prevIndex10 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>
            </div>

            <div className="custom-img-gallery">
              <div key={11} className="list">
                {array11 &&
                  array11?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex3 === 1 && randomIndex3 === index
                          ? "hide show"
                          : rowListIndex3 !== 1 && prevIndex11 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>
              <div key={12} className="list">
                {array12 &&
                  array12?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex3 === 2 && randomIndex3 === index
                          ? "hide show"
                          : rowListIndex3 !== 2 && prevIndex12 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>
              <div key={13} className="list">
                {array13 &&
                  array13?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex3 === 3 && randomIndex3 === index
                          ? "hide show"
                          : rowListIndex3 !== 3 && prevIndex13 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>
              <div key={14} className="list">
                {array14 &&
                  array14?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex3 === 4 && randomIndex3 === index
                          ? "hide show"
                          : rowListIndex3 !== 4 && prevIndex14 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>
              {!isMobile && <div key={15} className="list">
                {array15 &&
                  array15?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        rowListIndex3 === 5 && randomIndex3 === index
                          ? "hide show"
                          : rowListIndex3 !== 5 && prevIndex15 === index
                          ? "show hide"
                          : "hide"
                      }
                    >
                      <a href={`/releases?labelName=${image?.name}`}>
                        <img
                          src={image?.logo}
                          alt={image?.name}
                          width="226"
                          height="151"
                        />
                      </a>
                    </div>
                  ))}
              </div>}
            </div>
          </div>

          <Link className="rounded-btn list-bottom-btn" to="/labels">
            Explore our full record label directory
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25.625"
              height="17.623"
              viewBox="0 0 25.625 17.623"
            >
              <g
                id="Group_280"
                data-name="Group 280"
                transform="translate(6855.444 -343.358) rotate(180)"
              >
                <path
                  id="Path_13"
                  data-name="Path 13"
                  d="M6838.983-343.712l-8.458-8.458,8.458-8.458"
                  transform="translate(0.001 0)"
                  fill="none"
                  stroke="#fff"
                  stroke-width="1"
                ></path>
                <line
                  id="Line_7"
                  data-name="Line 7"
                  x2="24.5"
                  transform="translate(6830.944 -352.426)"
                  fill="none"
                  stroke="#fff"
                  stroke-width="1"
                ></line>
              </g>
            </svg>
          </Link>
          <div className="services-lists full-view">
            <div className="service-list-header">
              <VinylManufacturing />
              <Typography.Title level={4}>Vinyl Manufacturing</Typography.Title>
            </div>
            <Image
              data-aos="fade-up"
              preview={false}
              className="service-main-img"
              src={ServiceImg3}
            />
            <Row className="service-list-content">
              <Col className="service-list-left" sm={24} xl={11}>
                <Typography.Text>
                We have spent decades building strong relationships with the leading pressing plants, meaning that we can offer a comprehensive range of options for vinyl manufacture at competitive prices.
                </Typography.Text>
              </Col>
              <Col className="service-list-right" sm={24} xl={11}>
                <Typography.Text className="last">
                Whatever the specification, weight, colour and packaging you have in mind, we can make this a reality. From P&D deals to mastering we cover all aspects of getting your release to you.
                </Typography.Text>
              </Col>
            </Row>

            <a
              className="rounded-btn list-bottom-btn"
              href={`mailto:info@primedirectdist.co.uk?subject=PDD%20Pressing%20Quote`}
            >
              Contact us for a tailored quote
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25.625"
                height="17.623"
                viewBox="0 0 25.625 17.623"
              >
                <g
                  id="Group_280"
                  data-name="Group 280"
                  transform="translate(6855.444 -343.358) rotate(180)"
                >
                  <path
                    id="Path_13"
                    data-name="Path 13"
                    d="M6838.983-343.712l-8.458-8.458,8.458-8.458"
                    transform="translate(0.001 0)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  ></path>
                  <line
                    id="Line_7"
                    data-name="Line 7"
                    x2="24.5"
                    transform="translate(6830.944 -352.426)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  ></line>
                </g>
              </svg>
            </a>
          </div>
          <div className="services-lists two-view">
            <Row>
              <Col sm={24} xl={11}>
                <Image
                  data-aos="fade-up"
                  preview={false}
                  className="service-main-img"
                  src={ServiceImg4}
                />
                <div className="service-list-header">
                  <Marketing />
                  <Typography.Title level={4}>
                    Marketing, Social Media, PR, Radio & Playlist Promotion
                  </Typography.Title>
                </div>
                <div className="service-list-content">
                  <Typography.Text>
                  Working alongside selected partners we offer promotion across radio, playlists, print, social media and web - all key aspects in getting your music heard around the world.
                  </Typography.Text>
                </div>
                <Button
                  className="rounded-btn"
                  shape="circle"
                  onClick={() => sendMail()}
                >
                  Enquire about marketing
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25.625"
                    height="17.623"
                    viewBox="0 0 25.625 17.623"
                  >
                    <g
                      id="Group_280"
                      data-name="Group 280"
                      transform="translate(6855.444 -343.358) rotate(180)"
                    >
                      <path
                        id="Path_13"
                        data-name="Path 13"
                        d="M6838.983-343.712l-8.458-8.458,8.458-8.458"
                        transform="translate(0.001 0)"
                        fill="none"
                        stroke="#fff"
                        stroke-width="1"
                      ></path>
                      <line
                        id="Line_7"
                        data-name="Line 7"
                        x2="24.5"
                        transform="translate(6830.944 -352.426)"
                        fill="none"
                        stroke="#fff"
                        stroke-width="1"
                      ></line>
                    </g>
                  </svg>
                </Button>
              </Col>
              <Col sm={24} xl={11}>
                <Image
                  data-aos="fade-up"
                  preview={false}
                  className="service-main-img"
                  src={ServiceImg5}
                />
                <div className="service-list-header">
                  <TradeAccount />
                  <Typography.Title level={4}>Trade Accounts</Typography.Title>
                </div>
                <div className="service-list-content">
                  <Typography.Text>
                  Prime Direct Distribution is a wholesale trade only distributor, selling to retailers and record stores around the world. If you would like to create a trade account with us, please fill out our account application form below. 
                  </Typography.Text>
                </div>
                <a href={pdfFile} target="_blank" rel="noreferrer">
                  <Button className="rounded-btn" shape="circle">
                    Create trade account
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25.625"
                      height="17.623"
                      viewBox="0 0 25.625 17.623"
                    >
                      <g
                        id="Group_280"
                        data-name="Group 280"
                        transform="translate(6855.444 -343.358) rotate(180)"
                      >
                        <path
                          id="Path_13"
                          data-name="Path 13"
                          d="M6838.983-343.712l-8.458-8.458,8.458-8.458"
                          transform="translate(0.001 0)"
                          fill="none"
                          stroke="#fff"
                          stroke-width="1"
                        ></path>
                        <line
                          id="Line_7"
                          data-name="Line 7"
                          x2="24.5"
                          transform="translate(6830.944 -352.426)"
                          fill="none"
                          stroke="#fff"
                          stroke-width="1"
                        ></line>
                      </g>
                    </svg>
                  </Button>
                </a>
              </Col>
            </Row>
          </div>
        </Content>
      </div>
    </div>
  );
};

export default ServicesContent;
